import { render, staticRenderFns } from "./LandingPage.vue?vue&type=template&id=1c0d9c08"
var script = {}
import style0 from "./LandingPage.vue?vue&type=style&index=0&id=1c0d9c08&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myagent\\_work\\14\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c0d9c08')) {
      api.createRecord('1c0d9c08', component.options)
    } else {
      api.reload('1c0d9c08', component.options)
    }
    module.hot.accept("./LandingPage.vue?vue&type=template&id=1c0d9c08", function () {
      api.rerender('1c0d9c08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LandingPage.vue"
export default component.exports